import { useContext, useEffect, useState } from 'react'

import { Box, Button, Input, Modal, Text } from '@fairfashion/design-system'

import { AuthContext } from '../../../../contexts/auth'
import { isEmail } from '../../../../utilities/strings/isEmail'

import { ForgotPasswordModalProps } from './forgot-password-modal.types'

export const ForgotPasswordModal = ({
  open,
  onClose,
}: ForgotPasswordModalProps) => {
  const [email, setEmail] = useState('')

  const {
    recoveryPassword,
    recoveryResponse,
    recoveryLoading,
    errorForgotPassword,
  } = useContext(AuthContext)

  const handleSubmit = () => {
    if (email && isEmail(email)) {
      recoveryPassword(email)
    }
  }

  useEffect(() => {
    if (recoveryResponse) {
      onClose()
    }
  }, [recoveryResponse])

  return (
    <Modal open={open} onClose={onClose} title="Redefinir senha" width="600px">
      <Box direction="column" gap={2} padding={2} width="100%">
        <Text>Informe o e-mail da conta que deseja redefinir a sua senha</Text>
        <Input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          state={errorForgotPassword ? 'error' : 'default'}
          message={errorForgotPassword ? errorForgotPassword?.message : ''}
        />
        <Button
          width="100%"
          onClick={handleSubmit}
          disabled={recoveryLoading || !isEmail(email)}
        >
          Redefinir senha
        </Button>
      </Box>
    </Modal>
  )
}
